import { create } from 'zustand';
import type { SymbolType } from '@/components/symbol/symbol.type';

type SymbolState = {
  scrollRefs: Record<string, HTMLElement | null>;
  setScrollRefs: (name: string, ref: HTMLElement | null) => void;
  selectedSymbol: SymbolType;
  setSelectedSymbol: (symbol: SymbolState['selectedSymbol']) => void;
  selectedCategory: string;
  setSelectedCategory: (name: string) => void;
  scrollObserver: Record<SymbolState['selectedSymbol'], IntersectionObserver>;
  getCurrentObserver: () => IntersectionObserver;
  setScrollObserver: (slug: SymbolState['selectedSymbol'], root: HTMLElement) => void;
  disconnectScrollObserver: (slug: SymbolState['selectedSymbol']) => void;
};

export const useSymbolStore = create<SymbolState>()((set, get) => ({
  scrollRefs: {},
  setScrollRefs(name, ref) {
    set(({ scrollRefs }) => ({
      scrollRefs: {
        ...scrollRefs,
        [name]: ref,
      },
    }));
  },
  selectedSymbol: 'emoji',
  setSelectedSymbol(select) {
    set(() => ({
      selectedSymbol: select,
    }));
  },
  selectedCategory: '',
  setSelectedCategory(select) {
    set(() => ({
      selectedCategory: select,
    }));
  },
  scrollObserver: {} as Record<SymbolState['selectedSymbol'], IntersectionObserver>,
  getCurrentObserver: () => get().scrollObserver[get().selectedSymbol],
  setScrollObserver(slug, root) {
    const observer = new IntersectionObserver(
      (entries) => {
        const refs = get().scrollRefs;
        const key = Object.keys(refs).find((k) => refs[k] === entries[0]?.target) || '';

        if (entries[0]?.isIntersecting) {
          get().setSelectedCategory(key);
        }
      },
      {
        root,
        rootMargin: '0px 0px -158px 0px',
      },
    );
    set(({ scrollObserver }) => ({
      scrollObserver: { ...scrollObserver, [slug]: observer },
    }));
  },
  disconnectScrollObserver(slug) {
    const current = get().scrollObserver[slug];

    if (current) {
      current.disconnect();
    }
  },
}));
